var map = {
	"./en": 80925,
	"./en-au": 91028,
	"./en-au.js": 91028,
	"./en-ca": 76681,
	"./en-ca.js": 76681,
	"./en-gb": 1562,
	"./en-gb.js": 1562,
	"./en-ie": 39164,
	"./en-ie.js": 39164,
	"./en-il": 25682,
	"./en-il.js": 25682,
	"./en-in": 85423,
	"./en-in.js": 85423,
	"./en-nz": 63629,
	"./en-nz.js": 63629,
	"./en-sg": 90025,
	"./en-sg.js": 90025,
	"./en-tt": 83813,
	"./en-tt.js": 83813,
	"./en.js": 80925
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79273;